const config = {
    api: {
        baseUrl: process.env.REACT_APP_API_URL || 'http://127.0.0.1:9090',
    },
    bucket: {
        name: process.env.REACT_APP_BUCKET || 'dalala-app-qa',
    },
    contacts: {
        emailContacto: 'info@dalala.mx',
        emailSoporte: 'info@dalala.mx',
        whatsappUrl: 'https://wa.me/525513604778',
    },
}

export default config
